import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ConfigDefinitions } from "@app/definitions/types"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { TimePickerComponent } from "@app/utils/time-picker/time-picker.component"
import { CancelBtnComponent } from "@app/utils/utils.component"
import * as moment from "moment"

@Component({
	selector: "app-guest-cal-form",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		DatePickerComponent,
		TimePickerComponent,
		CancelBtnComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="row">
			<div class="col-6 col-md-4 ">
				<label>{{ "message" | langVal }}</label>
				<app-gen-input
					type="textarea"
					[actualObj]="actObject"
					title_ph_lang="message"
					fieldName="text"
				/>
			</div>
		</div>
		<div class="row">
			<div class="col-6 col-md-4 ">
				<label>{{ "date" | langVal }}</label>
				<app-date-picker
					[actualObj]="actObject"
					fieldName="date"
					title_ph_lang="date"
				/>
			</div>
		</div>
		<div class="row">
			<div class="col-6 col-md-4 ">
				<label>{{ "time" | langVal }}</label>
				<app-time-picker
					[actualObj]="actObject"
					fieldName="time"
				/>
			</div>
		</div>
		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<button
				class="btn btn-primary"
				tabindex="5"
				(click)="onClose.emit(actObject)"
			>
				{{ "close_btn" | langVal }}
			</button>
		</div>
	`,
})
export class GuestCalFormComponent extends Modalable {
	@Input() inputDate: any = null

	actObject: any = { text: "", date: "", time: "" }
	ngOnInit() {
		if (this.inputDate) {
			const d = moment.utc(this.inputDate)
			this.actObject.date = d.format(ConfigDefinitions.momentDateFormat)
			this.actObject.time = d.format("HH:mm")
		}
	}
}
